export default "__VITE_ASSET__24aa96c2__"